<template>
  <section class="reviews overflow-hidden">
    <img
      v-if="showScribble"
      src="/frontend/assets/scribble.svg"
      class="mx-auto my-4 lg:my-12 lg:h-[150px]"
    >

    <div class="container">
      <div class="text-center">
        <h2 class="text-4xl font-bold block sparkle-right text-center lg:text-5xl md:inline-block">
          {{ title }}
        </h2>

        <p class="text-lg text-center mt-2 text-gray-300 lg:text-xl">
          {{ __('components.reviews.title') }}
        </p>
      </div>

      <Splide
        :has-track="false"
        :options="sliderOptions"
      >
        <SplideTrack>
          <SplideSlide
            v-for="(review, i) in reviews"
            :key="`review-${i}`"
            class="bg-white rounded-lg mt-6 p-6 lg:p-8"
          >
            <div v-if="extended">
              <div class="flex flex-wrap">
                <div class="w-full lg:w-5/12">
                  <div class="max-w-full max-h-full rounded-lg">
                    <VideoPlayer
                      controls
                      :poster="review.poster"
                      :autoplay="false"
                      preload="none"
                      :src="review.video"
                      width="232"
                      height="413"
                    />
                  </div>
                </div>

                <div class="w-full flex flex-wrap items-center lg:w-7/12 lg:pl-6">
                  <div>
                    <img
                      src="/frontend/assets/quote.svg"
                      class="mb-4"
                    >
                    <p>{{ review.text }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <img
                src="/frontend/assets/quote.svg"
                class="mb-4"
              >
              <p>{{ review.text }}</p>
            </div>
          </SplideSlide>
        </SplideTrack>

        <div class="splide__arrows mt-4 text-center flex flex-wrap justify-center space-x-4 md:justify-start">
          <img
            src="/frontend/assets/round-arrow.svg"
            class="splide__arrow splide__arrow--prev cursor-pointer"
            title="Vorige"
            alt="Vorige"
          >
          <img
            src="/frontend/assets/round-arrow-orange.svg"
            class="splide__arrow splide__arrow--next rotate-180  cursor-pointer"
            title="Volgende"
            alt="Volgende"
          >
        </div>
      </Splide>
    </div>
  </section>
</template>

<script>
import pkg from '@splidejs/vue-splide';
const { Splide, SplideTrack, SplideSlide } = pkg;
import VideoPlayer from './VideoPlayer.vue';

export default {
  components: {
    VideoPlayer,
    Splide,
    SplideTrack,
    SplideSlide,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    showScribble: {
      type: Boolean,
      required: false,
      default: false,
    },

    extended: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      reviews: this.$tm('components.reviews.reviews'),

      sliderOptions: {
        gap: '1rem',
        perPage: 2,
        arrows: true,
        pagination: false,
        rewind: true,
        breakpoints: {
          640: {
            perPage: 1,
          },
        },
      },
    };
  },
};
</script>
